<template>
  <i :class="['svg-icon' ,'qs-icon_'+iconClass]"></i>
</template>

<script>
export default {
  name: "SvgIcon",
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: "",
    },
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`;
    },
    svgClass() {
      if (this.className) {
        return "svg-icon " + this.className;
      } else {
        return "svg-icon";
      }
    },
  },
};
</script>

<style lang="less">
.svg-icon {
  width: 18px;
  height: 18px;
  vertical-align: middle;
  margin-right: 10px;
}
</style>
